package dev.alimmz.portfolio.presentation.screen

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.mikepenz.markdown.m3.Markdown
import com.mikepenz.markdown.coil3.Coil3ImageTransformerImpl
import dev.alimmz.portfolio.data.markdown.GithubMarkdown
import dev.alimmz.portfolio.domain.model.Project
import kotlinx.coroutines.CancellationException

@Composable
fun ProjectReadme(project: Project) {
    var content by remember(project.link) { mutableStateOf<String?>(null) }
    var failed by remember(project.link) { mutableStateOf(false) }
    var attempt by remember(project.link) { mutableStateOf(0) }
    val uriHandler = LocalUriHandler.current
    LaunchedEffect(project.link, attempt) {
        failed = false
        try { content = GithubMarkdown.load(project.link) }
        catch (cancelled: CancellationException) { throw cancelled }
        catch (_: Exception) { failed = true }
    }
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(20.dp)) {
        Text("Inside the project", style = MaterialTheme.typography.headlineMedium)
        when {
            failed -> {
                Text("The project documentation couldn't be loaded. Check your connection or try again. The repository may be private or GitHub's request limit may have been reached.")
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    Button(onClick = { attempt++ }) { Text("Try again") }
                    TextButton(onClick = { uriHandler.openUri(project.link) }) { Text("Open GitHub") }
                }
            }
            content == null -> {
                LinearProgressIndicator(Modifier.fillMaxWidth())
                Text("Loading project documentation…")
            }
            else -> SelectionContainer {
                Markdown(content!!, imageTransformer = Coil3ImageTransformerImpl, modifier = Modifier.fillMaxWidth())
            }
        }
    }
}
